import * as angular from "angular";
import * as _ from "lodash";

export class SubTasksDialogService {

  /* @ngInject */
  constructor(private $mdDialog) {
  }

  createTemplate(actions, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-sub-task-template-dialog.html').default,
      controller: function ($scope, tagsConstants) {

        $scope.subTask = {};
        $scope.actionOptions = angular.copy(actions);
        $scope.tagTypes = [tagsConstants.subTaskType];

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////

        // ******************************
        // Public methods
        // ******************************

        $scope.onSubTaskChanged = (subTask) => {
          $scope.subTask = subTask;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.subTask);
            }
          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }

  editTemplate(actions, subTaskTemplate, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-sub-task-template-dialog.html').default,
      controller: function ($scope, tagsConstants) {

        $scope.subTask = angular.copy(subTaskTemplate);
        $scope.actionOptions = angular.copy(actions);
        $scope.tagTypes = [tagsConstants.subTaskType];


        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////

        // ******************************
        // Public methods
        // ******************************

        $scope.onSubTaskChanged = (subTask) => {
          $scope.subTask = subTask;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.subTask);
            }
          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }

  selectTemplate(originalTemplateIds, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/select-sub-task-template-dialog.html').default,
      controller: function ($scope) {

        $scope.originalTemplateIds = originalTemplateIds;
        $scope.selectedTemplateIds = [];
        $scope.templateTypes = ['Operational'];

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////

        // ******************************
        // Public methods
        // ******************************

        $scope.onTemplateSelect = (templates) => {
          $scope.selectedTemplates = templates;
          $scope.selectedTemplateIds = _.map(templates, 'templateId');
        }

        $scope.onSubmit = () => {
          self.$mdDialog.hide($scope.selectedTemplates);
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }
}

angular
  .module('bringoz.admin.sub-tasks')
  .service('subTasksDialogService', SubTasksDialogService);
